module.exports = __webpack_public_path__ + "static/media/IMG_0342.24633290.JPG";